// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__19srq","inputWrap":"styles_inputWrap__3ugbi","input":"styles_input__q9Wtf"};